import { transformPaginationDto } from '@marketplace-web/domain/pagination-data'
import { transformUserDtos } from '@marketplace-web/shared/user-data'
import { UsersResp } from 'types/api/response/users-resp'

export const transformUsersResponse = (response: UsersResp) => ({
  users: transformUserDtos(response.users),
  pagination: transformPaginationDto(response.pagination),
})
